import Icon from '../components/Icon.vue'

Icon.register({
  'redo-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256.5 8c66.3 0.1 126.4 26.2 170.9 68.7l35.7-35.7c15.1-15.1 41-4.4 41 17v134.1c0 13.3-10.7 24-24 24h-134.1c-21.4 0-32.1-25.9-17-41l41.8-41.8c-30.9-28.9-70.8-44.9-113.2-45.3-92.4-0.8-170.3 74-169.5 169.4 0.8 90.6 74.2 166.6 168 166.6 41.1 0 80-14.7 110.6-41.6 4.7-4.2 11.9-3.9 16.4 0.6l39.7 39.7c4.9 4.9 4.6 12.8-0.5 17.4-44 39.7-102.3 63.9-166.2 63.9-137 0-248-111-248-248 0-136.8 111.6-248.2 248.5-248z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/redo-alt.js
// module id = 1683
// module chunks = 0